// extracted by mini-css-extract-plugin
export default {"bankDetails":"vY4qn2eRZHyxtkKadq3a","placeHolderShimmer":"Jy_nVryF0_YMQABnCYa9"};